import { useParams, useLocation } from 'react-router-dom';
import DetailLayout from '../layout/DetailLayout';

function DetailView({ socket, selectedWhatsAppSetting }) {
  const { objectName, id } = useParams();
  console.log('Object View Wrapper-->');
  return (
    <DetailLayout
      objectName={objectName}
      id={id}
      socket={socket}
      selectedWhatsAppSetting={selectedWhatsAppSetting}
    ></DetailLayout>
  );
}
export default DetailView;
